import styled from 'styled-components';

export const RoomDetails = styled.div`
  margin-bottom: 2rem;
`;

export const RoomSection = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const RoomFormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
`;
